import BaseHttp from '../../../plugins/baseHttp';

import _api from '../../franchises/_api';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    user: {},
    franchise: localStorage.getItem('franchise',),
    franchisesIds: [],
  },
  // -----------------------------------------------------------------
  getters: {
    user: (state,) => state.user,
    franchises: (state,) => {
      if (!Object.keys(state.user,).length) {return [];}
      return state.user['https://deliverymuch.com.br'].franchises;
    },
    sortedFranchises: ({user,},) => {
      if (!Object.keys(user,).length) {return [];}

      const franchises = user['https://deliverymuch.com.br'].franchises;

      return franchises.sort((a,b,) => (a.name > b.name) ? 1 :
        ((b.name > a.name) ? -1 : 0),);
    },
    multipleFranchises: (state,) => {
      return ((state.user['https://deliverymuch.com.br'] || {}).franchises || []).length > 1
        ? true
        : false;
    },
    getPermissions: ({ user, },) => {
      return user.permissions.reduce(( grouped, { name, },) => {
        const permission = name.split`_`,
          suffix = permission.pop(),
          prefix = permission.join`_`;

        if (!grouped[suffix]) {
          grouped[suffix] = {};
        }

        grouped[suffix][prefix] = true;
        return grouped;
      }, {},);
    },
    currentFranchise: (state,) => state.franchise,
    isLogged: (state,) => !!Object.keys(state.user,).length,
    franchisesIds: (state,) => state.franchisesIds,
    getUserSawNewFeatureModal (state,) {
      return JSON.parse(localStorage.getItem(`new_store_onboarding_${state.user.email}`,),);
    },
    getUserSawCreateStoreModal (state,) {
      return JSON.parse(localStorage.getItem(`v2_create_store_onboarding_${state.user.email}`,),);
    },
    getUserSawViewStoreModal (state,) {
      return JSON.parse(localStorage.getItem(`v2_view_store_onboarding_${state.user.email}`,),);
    },
    BUSINESS_TYPES () {
      return {
        FRANCHISOR: 'Franqueadora',
        FRANCHISE: 'Franquia',
      };
    },
    isUserFranchisor (state, getters,) {
      return state.user?.businessType === getters.BUSINESS_TYPES.FRANCHISOR;
    },
    isUserFranchise (state, getters,) {
      return state.user?.businessType === getters.BUSINESS_TYPES.FRANCHISE;
    },
  },
  // -----------------------------------------------------------------
  mutations: {
    setUser: (state, user,) => {
      state.user = user;
    },
    setCurrentFranchise: (state, franchise,) => {
      state.franchise = franchise;
      localStorage.setItem('franchise', franchise,);
    },
    setFranchisesIds: (state, franchisesIds,) => {
      state.franchisesIds = franchisesIds;
    },
    setShowModalByUser: (state, modalName,) => {
      localStorage.setItem(`${modalName}_onboarding_${state.user.email}`, true,);
    },
  },
  // -----------------------------------------------------------------
  actions: {
    setUser: async (store, user,) => {
      await BaseHttp.setAccessToken(localStorage.getItem('access_token',),);
      const limitFranchisesLength = user?.franchises?.length ?? 9999;
      const userFranchises = await _api.getUserFranchises(limitFranchisesLength,);
      user['https://deliverymuch.com.br'].franchises = userFranchises.data.map((franchise,) => ({
        ...franchise,
        name: franchise.name === 'AA - Franquias  - RS' ? 'Manoel Viana - RS' : franchise.name,
      }),);
      const franchises = user['https://deliverymuch.com.br'].franchises;
      if (franchises.length === 1) {
        store.commit('setCurrentFranchise', franchises[0].id,);
      }
      store.dispatch('setBaseFranchise', store.getters.currentFranchise,);
      store.commit('setUser', user,);
    },
    setCurrentFranchise: (store, franchise,) => {
      store.commit('setCurrentFranchise', franchise,);
    },
    setBaseFranchise: (store, franchise,) => {
      BaseHttp.setFranchise(franchise,);
    },
    getFranchisesIds: (store,) => {
      let franchisesIds = new Set(
        store.getters.
          user.franchises.filter((franchise,) => franchise.marketplace_franchise_id > 0,).
          map((franchise,) => franchise.marketplace_franchise_id,),);
      franchisesIds = Array.from(franchisesIds.values(),);
      store.commit('setFranchisesIds', franchisesIds,);
    },
    setOnboardingModalUser: ({ commit, }, modalName,) => {
      commit('setShowModalByUser', modalName,);
    },
  },
};
